import { useEffect, useRef, useCallback } from "react";

const IDLE_EVENTS = ["mousemove", "mousedown", "keydown", "touchstart", "scroll", "click"];

export function useIdleTimer({ warnAfterMs = 25 * 60 * 1000, expireAfterMs = 30 * 60 * 1000, onWarn, onExpire, enabled = true }) {
  const warnRef = useRef(null);
  const expireRef = useRef(null);

  const reset = useCallback(() => {
    clearTimeout(warnRef.current);
    clearTimeout(expireRef.current);
    if (!enabled) return;
    warnRef.current = setTimeout(onWarn, warnAfterMs);
    expireRef.current = setTimeout(onExpire, expireAfterMs);
  }, [onWarn, onExpire, warnAfterMs, expireAfterMs, enabled]);

  useEffect(() => {
    if (!enabled) return;
    reset();
    IDLE_EVENTS.forEach((e) => window.addEventListener(e, reset, { passive: true }));
    return () => {
      clearTimeout(warnRef.current);
      clearTimeout(expireRef.current);
      IDLE_EVENTS.forEach((e) => window.removeEventListener(e, reset));
    };
  }, [reset, enabled]);

  return { reset };
}
